
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__star-outline",
  "use": "icon__star-outline-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon__star-outline\"><defs><clipPath id=\"icon__star-outline_a\"><path d=\"M1280 0v565H0V0h1280z\" /></clipPath><clipPath id=\"icon__star-outline_b\"><path fill=\"#FFF\" d=\"m10.465 0 3.057 7.257 7.402.805-5.536 5.226L16.958 21l-6.493-3.955L3.967 21l1.575-7.712L0 8.062l7.408-.805 2.369-5.624L10.465 0zm0 3.844L8.441 8.645l-5.058.548 3.786 3.582-1.056 5.168 4.352-2.648 4.346 2.648-1.05-5.168 3.791-3.582-5.063-.548-2.024-4.8z\" /></clipPath></defs><g clip-path=\"url(#icon__star-outline_a)\" transform=\"translate(-580 -227)\"><g clip-path=\"url(#icon__star-outline_b)\" transform=\"translate(581.5 228.5)\"><path fill=\"#1C8AFE\" d=\"M0 0h20.924v21H0V0z\" /></g></g></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconStarOutlineIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__star-outline" {...restProps} />
    })
  